import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    data() {
        return {
            countries: [],  // Array to hold the fetched countries
            loading: false, // State for loading indicator
            error: null,    // State for handling errors
        };
    },
    methods: {
        async getCountries() {
            this.loading = true;
            this.error = null;

            try {
                const url = `${serverUrl}Country`;
                const response = await axios.get(url);
                this.countries = response.data; // Assuming the API returns an array of countries
            } catch (err) {
                this.error = "Failed to fetch countries"; // Handle the error
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
